export const dyPageGroupTypes = {
  HOME: 'home_abtest',
  PLP: 'plp_abtest',
  PDP: 'pdp_abtest',
  SEARCH: 'search_abtest',
  CART: 'cart_abtest',
  CHECKOUT: 'checkout_abtest',
  OUTFIT: 'outfit_abtest',
  GLOBAL: 'global_abtest',
};

export const dyPageGroups = {
  HOME: [dyPageGroupTypes.HOME, dyPageGroupTypes.GLOBAL],
  PLP: [dyPageGroupTypes.PLP, dyPageGroupTypes.GLOBAL],
  PDP: [dyPageGroupTypes.PDP, dyPageGroupTypes.GLOBAL],
  SEARCH: [dyPageGroupTypes.SEARCH, dyPageGroupTypes.GLOBAL],
  CART: [dyPageGroupTypes.CART, dyPageGroupTypes.GLOBAL],
  CHECKOUT: [dyPageGroupTypes.CHECKOUT, dyPageGroupTypes.GLOBAL],
  OUTFIT: [dyPageGroupTypes.OUTFIT, dyPageGroupTypes.GLOBAL],
  GLOBAL: [dyPageGroupTypes.GLOBAL],
};

export const dyPageTypes = {
  HOME: 'HOME',
  PLP: 'PLP',
  PDP: 'PRODUCT',
  SEARCH: 'SEARCH',
  CART: 'CART',
  CHECKOUT: 'CHECKOUT',
  OUTFIT: 'OUTFIT',
  OTHER: 'OTHER', // Keeping this as it's used as a fallback
};
